import { getIntl } from "client/utils/internationalization";

import { Field } from "../../field";
import { Merchant } from "../../merchant";
import { I18nValues, MerchantField } from "../../types";
import { getBankAccountI18nKeys } from "../../utils/getBankAccountStringKeys";

import { determineSecondBankFormEligibility } from "./utils";

export class BankAccountNameField extends Field<string> {
  constructor(
    model: Merchant,
    { propertyName }: { propertyName: string },
    opts: Partial<MerchantField<string>> = {}
  ) {
    super(model, {
      dataType: "string",
      testValue: "bigBank",
      propertyName,
      uiFieldType: "Input",
      ...opts,
    });
  }

  get i18nValues(): I18nValues {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const businessType = this._model.companyInformation.businessType.value;

    const t = getIntl(registeredCountry);
    const bankAccountFieldSet =
      this.propertyName === "bankAccountName"
        ? "PrimaryBankAccountFieldSet"
        : "SecondaryBankAccountFieldSet";

    const { labelKey, helperTextKey } = getBankAccountI18nKeys(
      businessType,
      registeredCountry,
      bankAccountFieldSet
    );
    return {
      label: t(labelKey),
      placeholder: t(`${this.propertyName}_Placeholder`),
      helperText: t(helperTextKey),
    };
  }

  get applicable(): boolean {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    const salesChannel = this._model.storeDetails.salesChannel.value;

    if (this.propertyName === "bankAccountName2") {
      return determineSecondBankFormEligibility({
        salesChannel,
        registeredCountry,
      });
    }
    return true;
  }

  get required(): boolean {
    if (this.propertyName === "bankAccountName2") {
      const secondaryBankInfo = this._model.secondaryBank;
      // don't require the field when all fields are left blank
      return (
        secondaryBankInfo.fields
          .filter((field) => field.shown)
          .some((field) => field.value) && this.applicable
      );
    }
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
